/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Snowflake integration configuration
*/
export class SnowflakeIntegrationConfig {
  'warehouse'?: string;
  'accountName'?: string;
  'oauth2ClientId'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "warehouse",
      "baseName": "warehouse",
      "type": "string",
      "format": ""
    },
    {
      "name": "accountName",
      "baseName": "accountName",
      "type": "string",
      "format": ""
    },
    {
      "name": "oauth2ClientId",
      "baseName": "oauth2ClientId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SnowflakeIntegrationConfig.attributeTypeMap;
  }

  public constructor() {
  }
}

